import React from 'react';
import ClassComponentOld from './ClassComponent';
import ClassComponentNew from './ClassComponentNew';

const ClassComponent = (props: any) => {
  if (props.new) {
    return <ClassComponentNew {...props} />;
  }
  return <ClassComponentOld {...props} />;
};

export default ClassComponent;
